import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export function useMaxVariants() {
  const $ = _c(5);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => user && "/api/dashboard/customer/max-product-variants";
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: maxVariants
  } = useSWR(t1, fetcher);
  let t2;
  if ($[3] !== maxVariants) {
    t2 = {
      maxVariants
    };
    $[3] = maxVariants;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}